<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-12 14:46:07
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-27 16:41:01
 * @FilePath: \合联\oms\src\view\finances\segmentDetails\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/finance/segmentDetails";
export default {
  name: "segmentDetails",
  components: {
    cTable
  },
  props: {
    tabName: {
      type: String,
      default: "S_ALL"
    }
  },
  mounted() {
    this.config.tabName = this.tabName;
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          p.dataType = this.tabName;
          return apis.list(p);
        }
      },
      config: {
        slot: "div",
        tabName: this.tabName,
        contentMethod({ row, column }) {
          if (column.type == "calculate_status" && row.calculate_msg) {
            return row.calculate_msg;
          }
        },
        isGetList: true
      },
      footer: {},
      modals: {
        upload: {
          methods: {
            ok() {
              window.open(this.$globalUrl + "/excel/tmp/TEMUWeightTpl.xlsx");
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("excel", {
                      file
                    })
                    .then(res => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        },
        createBill: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data.dataType = this.$page.config.tabName;
              this.$page
                .handleRequestMethods("createBill", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 30
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            default: "1",
            options: [
              {
                label: this.$tz("出库,时间"),
                value: "1"
              },
              {
                label: this.$tz("POD,时间"),
                value: "2"
              }
            ]
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("billingStatus");
            },
            clearable: true,
            options: [
              { label: this.$t("billFailed"), value: 0 },
              {
                label: this.$t("billSuccess"),
                value: 1
              }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "finance_status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("cod_status");
            },
            clearable: true,
            options: [
              { label: this.$t("noOrder"), value: 0 },
              { label: this.$t("isOrder"), value: 1 },
              { label: this.$t("objection"), value: 3 },
              { label: this.$t("Settled"), value: 9 }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            optionsFn: "getAllClient"
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            optionsFn: "salesman"
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry"
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 2
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              show: () => {
                return ["S_END", "S_BEG"].includes(this.tabName);
              }
            },
            {
              name: () => this.$tz("重新计算"),
              type: "recalculate",
              fnName: "recalculate",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("同步数据"),
              type: "sync",
              fnName: "sync",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("创建账单"),
              type: "create",
              fnName: "create",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("TM,重量,上传"),
              type: "import",
              fnName: "import",
              bind: {
                type: "primary"
              },
              show: () => {
                return ["S_BEG"].includes(this.tabName);
              }
            }
          ],
          methods: {
            import() {
              this.getModal("upload").open({}, function() {
                this.setTitle(this.$tz("TM,重量,上传"));
              });
            },
            export({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({}, searchForm, { export: 1 }),
                false,
                true
              ).then(res => {
                this.$Message["success"]({
                    background: true,
                    content: "请到导出管理下载",
                    duration: 5
                  });
              });
              
            },
            create() {
              this.getModal("createBill").open({}, function() {
                this.setTitle(this.$tz("创建账单"));
              });
            },
            sync() {
              this.$Modal.confirm({
                title: this.$tz("同步数据"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "sync",
                    {
                      dataType: this.config.tabName
                    },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            },
            recalculate() {
              this.$Modal.confirm({
                title: this.$tz("重新计算"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "recalculate",
                    {
                      ids: this.selectAll.map(t => t.id),
                      dataType: this.config.tabName
                    },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$tz("出货日期"),
          key: "outbound_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("客户名称"),
          key: "clientInfo.client_account",
          minWidth: 120
        },
        {
          name: () => this.$tz("出货单号"),
          key: "airway_bill_number",
          minWidth: 120
        },
        {
          name: () => this.$tz("原单号"),
          key: "client_refer_code",
          minWidth: 120
        },
        {
          name: () => this.$tz("起运国家"),
          key: "from_country",
          minWidth: 120
        },
        {
          name: () => this.$tz("目的国家"),
          key: "to_country",
          minWidth: 120
        },
        {
          name: () => this.$tz("目的地"),
          key: "shipment.city_name",
          minWidth: 120
        },
        {
          name: () => this.$tz("分区"),
          key: "shipment.city_partition",
          minWidth: 120
        },
        {
          name: () => this.$tz("TM,重量,/,体积,信息"),
          children: [
            {
              name: () => this.$tz("预报,重量") + "(g)",
              key: "shipment.claim_weight",
              minWidth: 100
            },
            {
              name: () => this.$tz("DWS,重量") + "(g)",
              key: "customer_weight.u_actual_weight",
              minWidth: 100
            },
            {
              name: () => this.$tz("DWS,体积,重量") + "(g)",
              key: "customer_weight.u_volume_weight",
              minWidth: 100
            },
            {
              name: () => this.$tz("DWS,尺寸") + "(cm)",
              key: "customer_weight.volume",
              minWidth: 100
            },
            {
              name: () => this.$tz("DWS,计费重量") + "(g)",
              key: "customer_weight.u_charge_weight",
              minWidth: 100
            }
          ]
        },
        {
          name: () => this.$tz("VNLIN,重量,/,体积,信息"),
          children: [
            {
              name: () => this.$tz("实际重量") + "(g)",
              key: "shipment.check_weight",
              minWidth: 100
            },
            {
              name: () => this.$tz("尺寸,数据") + "(cm)",
              key: "shipment.volume",
              minWidth: 100
            },
            {
              name: () => this.$tz("体积,系数"),
              key: "shipment.volume_size",
              minWidth: 100
            },
            {
              name: () => this.$tz("体积,重量") + "(g)",
              key: "shipment.charge_volume",
              minWidth: 100
            },
            {
              name: () => this.$tz("计费重量") + "(g)",
              key: "charge_params",
              minWidth: 100
            }
          ]
        },
        {
          name: () => this.$tz("重量差异") + "(g)",
          key: "diff_weight",
          minWidth: 110
        },
        {
          name: () => this.$tz("差异率"),
          key: "diff_rate",
          minWidth: 110
        },
        {
          name: () => this.$tz("最终,计费重量") + "(g)",
          key: "final_charge_weight",
          minWidth: 110
        },
        {
          name: () => this.$tz("城市分区"),
          key: "shipment.city_partition",
          minWidth: 110,
          show: () => this.tabName == "S_END"
        },

        {
          name: () => this.$tz("申报价值"),
          key: "shipment.values",
          minWidth: 100
        },
        {
          name: () => this.$tz("费用"),
          show: () => {
            return this.tabName !== "S_ALL";
          },
          children: [
            {
              name: () => this.$tz("币种"),
              key: "financeFeesInfo.currency",
              minWidth: 110
            },
            {
              name: () => this.$tz("头程费用"),
              key: "financeFeesInfo.first_charge_fee",
              minWidth: 100,
              show: () => {
                return this.tabName != "S_END";
              }
            },
            {
              name: () => this.$tz("清关,费用"),
              key: "financeFeesInfo.customs_clearance_fee",
              minWidth: 110,
              show: () => this.tabName != "S_END"
            },
            {
              name: () => this.$tz("尾程费用"),
              key: "financeFeesInfo.end_delivery_fee",
              minWidth: 100,
              show: () => this.tabName == "S_END"
            },
            {
              name: () => this.$tz("COD,手续费"),
              key: "financeFeesInfo.cod_collect_fee",
              minWidth: 110,
              show: () => this.tabName == "S_END"
            },
            {
              name: () => this.$tz("其他费用"),
              key: "financeFeesInfo.other_fee",
              minWidth: 100
            },
            {
              name: () => this.$tz("合计,应收金额"),
              key: "financeFeesInfo.total",
              minWidth: 100
            }
          ]
        },
        {
          name: () => this.$tz("COD,金额"),
          key: "shipment.cod_amount",
          minWidth: 120
        },
        {
          name: () => this.$tz("COD,币种"),
          key: "to_country_currency",
          minWidth: 120
        },
        {
          name: () => this.$t("bill_type"),
          key: "finance_status_txt",
          width: 80,
          methods: {
            render({ row }) {
              return row.finance_status_txt;
            }
          }
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          width: 110,
          noDeep: true,
          render: (h, { row }) => {
            return h(
              "a",
              {
                props: {
                  type: "warning",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.$refs["table"].toPage("segmentBill", row.bill_number);
                  }
                }
              },
              row.bill_number
            );
          }
        },
        {
          name: () => this.$tz("账单名称"),
          key: "quotation_name",
          minWidth: 110
        },
        {
          name: () => this.$t("exlType"),
          key: "calculate_status_txt",
          type: "calculate_status",
          minWidth: 80,
          noDeep: true,
          fixed: "right",
          bind: {
            style({ row }) {
              return {
                color: row.calculate_status == 1 ? "#4caf50" : "#f44336"
              };
            }
          },
          methods: {
            render: ({ row }) => {
              return row.calculate_status == 1
                ? this.$t("billSuccess")
                : this.$t("billFailed");
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
